import { render, staticRenderFns } from "./RoomList.vue?vue&type=template&id=0572baf8&scoped=true&"
import script from "./RoomList.vue?vue&type=script&lang=js&"
export * from "./RoomList.vue?vue&type=script&lang=js&"
import style0 from "./RoomList.vue?vue&type=style&index=0&id=0572baf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0572baf8",
  null
  
)

export default component.exports